<div class="sequence-step-numbers">
  {{#stepNums active num_steps}}
  <div class="step-number {{ className }}">{{ i }}</div>
  {{/stepNums}}
</div>

